import axios from "axios";

const prepareData = (data) => {return {approval_process:data}}

// Plural Actions
export const GET_APPROVAL_PROCESSES = "get_approval_processes";
export const getApprovalProcesses = () => {
	const url = `/approval_processes.json`
	const request = axios.get(url);
	return {
		type: GET_APPROVAL_PROCESSES,
		payload: request
	};
};


// Singular Actions
export const CREATE_APPROVAL_PROCESS = "create_approval_process";
export const createApprovalProcess = (data) => {
	const url = `/approval_processes.json`
	const request = axios({method: "post",url: url,data: prepareData(data)});
	return {
		type: CREATE_APPROVAL_PROCESS,
		payload: request
	};
};

export const GET_APPROVAL_PROCESS = "get_approval_process";
export const getApprovalProcess = (id) => {
	const url = `/approval_processes/${id}.json`
	const request = axios.get(url);
	return {
		type: GET_APPROVAL_PROCESS,
		payload: request
	};
};

export const UPDATE_APPROVAL_PROCESS = "update_approval_process";
export const updateApprovalProcess = (id,data) => {
	const url = `/approval_processes/${id}.json`
	const request = axios({method: "patch",url: url,data: prepareData(data)});
	return {
		type: UPDATE_APPROVAL_PROCESS,
		payload: request
	};
};

export const DESTROY_APPROVAL_PROCESS = "destroy_approval_process";
export const destroyApprovalProcess = (id) => {
	const url = `/approval_processes/${id}.json`
	const request = axios({method: "delete",url: url});
	return {
		type: DESTROY_APPROVAL_PROCESS,
		payload: request
	};
};
